import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/components/home/home'
import meHome from '@/components/home/meHome'
import Clientes from '@/components/clientes/clientes'
import Empresas from '@/components/empresas/empresas'
import Funcionarios from '@/components/funcionarios/funcionarios'
import Planos from '@/components/planos/planos'
import Status from '@/components/status/status'
import Transportes from '@/components/transportes/transportes'
import Configs from '@/components/configs/configs'
import Notificacoes from '@/components/configs/notificacoes'
import meFuncionarios from '@/components/configs/meFuncionarios'
import meClientes from '@/components/configs/meClientes'
import me from '@/components/configs/me'
import Senha from '@/components/configs/alteraSenha'
import Rastreio from '@/components/rastreio/rastreio'
import StatusRastreio from '@/components/rastreio/statusRastreio'
import MotoristaRastreio from '@/components/rastreio/motoristaRastreio'
import Login from '@/components/login/auth'
import Paradas from '@/components/paradas/paradas'
import RepClientes from '@/components/reports/clientes'
import RepFuncionarios from '@/components/reports/funcionarios'
import RepMotoristas from '@/components/reports/motoristas'
import RepLogTransportes from '@/components/reports/logTransportes'
import RepClienteTransportes from '@/components/reports/clienteTransportes'
import RepClientePeriodoTransportes from '@/components/reports/clientePeriodoTransportes'
import RepMotoristaTransportes from '@/components/reports/motoristaTransportes'
import RepMotoristaPeriodoTransportes from '@/components/reports/motoristaPeriodoTransportes'
import RepStatusTransportes from '@/components/reports/statusTransportes'
import RepStatusPeriodoTransportes from '@/components/reports/statusPeriodoTransportes'
import RepLateTransportes from '@/components/reports/lateTransportes'
import RepDisponibilidade from '@/components/reports/disponibilidade'
import Mapa from '@/components/mapa/mapa'
import dev from '@/components/dev/dev'

Vue.use(VueRouter)

const routes = [{
  name: 'home',
  path: '/home',
  component: Home
},{
  name: 'meHome',
  path: '/',
  component: meHome
},{
  name: 'clientes',
  path: '/clientes',
  component: Clientes
},{
  name: 'empresas',
  path: '/empresas',
  component: Empresas
},{
  name: 'funcionarios',
  path: '/funcionarios',
  component: Funcionarios
},{
  name: 'planos',
  path: '/planos',
  component: Planos
},{
  name: 'status',
  path: '/status',
  component: Status
},{
  name: 'transportes',
  path: '/transportes',
  component: Transportes
},{
  name: 'configs',
  path: '/configs',
  component: Configs
},{
  name: 'rastreio',
  path: '/rastreio/:id',
  component: Rastreio
},{
  name: 'rastreioPesquisa',
  path: '/rastreio',
  component: Rastreio
},{
  name: 'statusRastreio',
  path: '/statusRastreio',
  component: StatusRastreio
},{
  name: 'login',
  path: '/login',
  component: Login
},{
  name: 'motorista',
  path: '/motorista',
  component: MotoristaRastreio
},{
  name: 'paradas',
  path: '/paradas',
  component: Paradas
},{
  name: 'repClientes',
  path: '/report_clientes',
  component: RepClientes
},{
  name: 'repLateTransportes',
  path: '/report_lateTransportes',
  component: RepLateTransportes
},{
  name: 'repFuncionarios',
  path: '/report_funcionarios',
  component: RepFuncionarios
},{
  name: 'repMotoristas',
  path: '/report_motoristas',
  component: RepMotoristas
},{
  name: 'repLogTransportes',
  path: '/report_logTransportes',
  component: RepLogTransportes
},{
  name: 'repClienteTransportes',
  path: '/report_clienteTransportes',
  component: RepClienteTransportes
},{
  name: 'repClientePeriodoTransportes',
  path: '/report_clientePeriodoTransportes',
  component: RepClientePeriodoTransportes
},{
  name: 'repMotoristaTransportes',
  path: '/report_motoristaTransportes',
  component: RepMotoristaTransportes
},{
  name: 'repMotoristaPeriodoTransportes',
  path: '/report_motoristaPeriodoTransportes',
  component: RepMotoristaPeriodoTransportes
},{
  name: 'repStatusTransportes',
  path: '/report_statusTransportes',
  component: RepStatusTransportes
},{
  name: 'repStatusPeriodoTransportes',
  path: '/report_statusPeriodoTransportes',
  component: RepStatusPeriodoTransportes
},{
  name: 'notificacoes',
  path: '/notificacoes',
  component: Notificacoes
},{
  name: 'meClientes',
  path: '/meClientes',
  component: meClientes
},{
  name: 'meFuncionarios',
  path: '/meFuncionarios',
  component: meFuncionarios
},{
  name: 'me',
  path: '/me',
  component: me
},{
  name: 'senha',
  path: '/senha',
  component: Senha
},{
  name: 'repDisponibilidade',
  path: '/repDisponibilidade',
  component: RepDisponibilidade
},{
  name: 'mapa',
  path: '/mapa',
  component: Mapa
},{
  name: 'dev',
  path: '/dev',
  component: dev
}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
